import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {selectTrialDaysLeft, selectShowSubscriptionBanner
} from '../../selectors';
import style from '../../../../scss/subscriptionBanner.scss';
import store from '../../store';

@customElement('arc-subscription-banner')
export class SubscriptionBanner extends connect(store)(LitElement) {
	static styles = [style];

	static properties = {
		show: {type: Boolean},
	}

	stateChanged(state) {
		this.show = selectShowSubscriptionBanner(state);
	}

	render() {
		return this.show
			? html`
					<div class="subscriptionBanner">
						<span><arc-subscription-status type="banner"></arc-subscription-status></span>
						<arc-subscribe-button size="S"></arc-subscribe-button>
					</div>
			  `
			: '';
	}
}
